import $ from "jquery";

/**
 * Helper class for storing key/value pairs in the browser's localStorage that falls
 * back to using cookie storage if localStorage is not available or throws an error.
 *
 * @example
 *   SimpleStorage.setItem("group_id", 58);
 *   SimpleStorage.getItem("group_id");
 *   // => "58"
 */
class SimpleStorage {
  /**
   * Retrieves a value from localStorage or cookie storage for the given key.
   * All items are stored as strings, so they will be returned as strings.
   *
   * @param {string} key The identifier for the stored value
   * @returns {string} The value for the given key
   */
  static getItem(key) {
    if ($.cookie("local-storage-error")) {
      return $.cookie(key);
    }

    try {
      return global.localStorage.getItem(key);
    } catch (error) {
      $.cookie("local-storage-error", true);

      return null;
    }
  }

  /**
   * Sets a value in localStorage or cookie storage for the given key.
   * Booleans and numbers will be stored as strings.
   *
   * @param {string} key The identifier for storing the value
   * @param {boolean|number|string} value The value to store
   */
  static setItem(key, value) {
    if ($.cookie("local-storage-error")) {
      $.cookie(key, value);

      return;
    }

    try {
      global.localStorage.setItem(key, value);
    } catch (error) {
      $.cookie("local-storage-error", true);
      $.cookie(key, value);
    }
  }
}

export default SimpleStorage;
